<template>
  <el-tooltip
    v-if="hasBuyingPrice"
    :content="buyingPriceLabel"
    placement="top"
  >
    <span>{{ params.data.supplierName }}</span>
  </el-tooltip>
  <span v-else>{{ params.data.supplierName }}</span>
</template>

<script>
export default {
  computed: {
    hasBuyingPrice() {
      return (
        this.params.data.buyingPrice !== undefined &&
        this.params.data.buyingPrice !== null
      );
    },
    buyingPriceLabel() {
      const formatted = this.$options.filters.formatCurrency(
        this.params.data.buyingPrice,
        this.$i18n.locale
      );
      return `${this.$t("buyingPrice")}: ${formatted}`;
    },
  },
};
</script>

<i18n>
{
  "en": {
    "buyingPrice": "Buying price"
  },
  "fr": {
    "buyingPrice": "Prix d'achat"
  },
  "de": {
    "buyingPrice": "Kaufpreis"
  }
}
</i18n>
